export default {
  disasterAvoidPolygons: {
    name: 'Nome',
    description: 'Descrizione',
    disasterType: 'Tipo di disastro',
    disasterSubType: 'Sottotipo di disastro',
    fillRequiredFields: 'Si prega di compilare i campi richiesti per l\'area del disastro',
    avoidAreaSaved: 'Zona disastrata salvata',
    avoidAreaDeleted: 'Area del disastro cancellata',
    fillAreaProperties: 'Riempi le proprietà dell\'area da evitare e salvalo',
    editProperties: 'Modifica proprietà',
    createADisasterPolygon: 'Crea un poligono di emergenza',
    createADisasterRectangle: 'Crea un rettangolo di emergenza',
    errorWhileTryingToSaveDisasterArea: 'Errore durante il tentativo di salvare l\'area del disastro',
    authorizationError: 'Errore di autorizzazione. Assicurati che la chiave inserita sia valida. Per inserire nuovamente la chiave ricaricare l\'app',
    disasterAreaUsageInfo: 'Puoi: spostare la visualizzazione della mappa per caricare le aree disastrate di una regione di destinazione, utilizzare gli strumenti di disegno poligonale per creare nuove aree disastrate e fare clic su un\'area disastrata per modificarla',
    errorCodes: {
      2404: 'Il fornitore non esiste',
      3404: 'Il tipo di disastro non esiste',
      5409: 'Nome dell\'area del disastro già in uso'
    },
    statuses: {
      401: 'Non autorizzato',
    }
  }
}
